/** @format */

export interface PaymentMethodsResponse {
  paymentMethods?: SavedPaymentMethod[];
  storedPaymentMethods?: StoredPaymentMethod[];
}

export interface SavedPaymentMethod {
  brands?: string[];
  name: string;
  type: string;
  brand?: string;
  configuration?: Configuration;
}

export interface Configuration {
  merchantId: string;
  gatewayMerchantId: string;
}

export interface StoredPaymentMethod {
  brand: string;
  expiryMonth: string;
  expiryYear: string;
  holderName: string;
  id: string;
  lastFour: string;
  name: string;
  networkTxReference: string;
  supportedRecurringProcessingModels: string[];
  supportedShopperInteractions: string[];
  type: string;
}
